module.exports = __webpack_public_path__ + "img/u4379.d23e48f7.svg";